(() => {
  const SELECTOR = '[data-youtube-exhibition]';

  function initYouTubeExhibition(section) {
    if (!section || section.dataset.swiperInitialized === 'true') {
      return;
    }

    const slider = section.querySelector('[data-youtube-swiper]');
    const previousButton = section.querySelector('[data-youtube-prev]');
    const nextButton = section.querySelector('[data-youtube-next]');

    if (!slider || typeof window.Swiper === 'undefined') {
      return;
    }

    const swiper = new window.Swiper(slider, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      speed: 700,
      watchOverflow: true,
      grabCursor: true,
      navigation: {
        prevEl: previousButton,
        nextEl: nextButton,
      },
      breakpoints: {
        480: {
          slidesPerView: 1.55,
          spaceBetween: 18,
        },
        750: {
          slidesPerView: 2.35,
          spaceBetween: 24,
        },
        990: {
          slidesPerView: 3.25,
          spaceBetween: 28,
        },
        1280: {
          slidesPerView: 4.15,
          spaceBetween: 32,
        },
      },
    });

    section.youtubeExhibitionSwiper = swiper;
    section.dataset.swiperInitialized = 'true';
  }

  function initAllYouTubeExhibitions(container = document) {
    container.querySelectorAll(SELECTOR).forEach(initYouTubeExhibition);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAllYouTubeExhibitions();
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches(SELECTOR)
      ? event.target
      : event.target.querySelector(SELECTOR);

    if (section) {
      initYouTubeExhibition(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches(SELECTOR)
      ? event.target
      : event.target.querySelector(SELECTOR);

    if (!section?.youtubeExhibitionSwiper) {
      return;
    }

    section.youtubeExhibitionSwiper.destroy(true, true);
    delete section.youtubeExhibitionSwiper;
    delete section.dataset.swiperInitialized;
  });
})();